module.exports = __webpack_public_path__ + "img/riskIcon_bg.60d3d2ad.png";